// src/screens/sales/executor/components/item/Item.tsx

import React from 'react'
import { ExecutorInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import copy from '../../../../../assets/images/icons/copy.svg'
import qr from '../../../../../assets/images/icons/qr.svg'
import { Toggle } from '../../../../../common/components/newToggle/Toggle'
import Share from '../../../../../common/components/share/Share'

type Props = {
  startEdit: (el: ExecutorInterface) => void
  startDuplicate: (el: ExecutorInterface) => void
  el: ExecutorInterface
  showDetails: (el: ExecutorInterface) => void
  onAttachUser: (executorId: number) => void
  onToggleActive: (executorId: number, isActive: boolean) => void
  onTogglePublish: (executorId: number, publish: boolean) => void
  onTogglePublishMotivation: (executorId: number, publishMotivation: boolean) => void
}

export const ListItem = ({
  startEdit,
  startDuplicate,
  el,
  showDetails,
  onAttachUser,
  onToggleActive,
  onTogglePublish,
  onTogglePublishMotivation,
}: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.position || '', 100)}</div>
          <div className={classes.phone}>
            <a href={`tel:${el.phone_number}`}>{el.phone_number}</a>
          </div>
          {el.user?.email && <div className={classes.email}>{el.user.email}</div>}
        </div>

        <div className={classes.settings}>
          {/* Группа: Статус */}
          <div className={classes.settingsGroup}>
            <div className={classes.settingsGroupTitle}>Статус</div>
            <div className={classes.settingsItem}>{el.userId ? '✅ Привязан' : '❌ Вакансия'}</div>
            <div className={classes.settingsRow}>
              <span className={el.isActive ? classes.settingsItem : classes.settingsItemInActive}>
                {el.isActive ? '✅ Активен' : '⛔ Не активен'}
              </span>
              <Toggle
                checked={el.isActive}
                onChange={(isChecked: boolean) => onToggleActive(el.id!, isChecked)}
                small
              />
            </div>
          </div>

          {/* Группа: Роли */}
          <div className={classes.settingsGroup}>
            <div className={classes.settingsGroupTitle}>Роли</div>
            <div className={classes.settingsItem}>
              {el.isDriver ? '🚚 Перевозчик' : '❌ Не перевозчик'}
            </div>
            <div className={classes.settingsItem}>
              {el.canServe ? '🛎️ Обслуживает' : '❌ Не обслуживает'}
            </div>
            <div className={classes.settingsItem}>
              {el.trackLocation ? '📍 Трекинг' : '❌ Нет трекинга'}
            </div>
          </div>

          {/* Группа: Публикация */}
          <div className={classes.settingsGroup}>
            {!el.userId && (
              <>
                <div className={classes.settingsGroupTitle}>Публикация</div>
                <div className={classes.settingsRow}>
                  <span className={classes.settingsItem}>
                    {el.publish ? '📢 Опубликован' : '🔇 Не опубликован'}
                  </span>
                  <Toggle
                    checked={el.publish}
                    onChange={(isChecked) => onTogglePublish(el.id!, isChecked)}
                    small
                  />
                </div>
                <div className={classes.settingsRow}>
                  <span className={classes.settingsItem}>
                    {el.publishMotivation ? '💰 Мотивация видна' : '💰 Мотивация скрыта'}
                  </span>
                  <Toggle
                    checked={el.publishMotivation}
                    onChange={(isChecked) => onTogglePublishMotivation(el.id!, isChecked)}
                    disabled={!el.publish}
                    small
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className={classes.buttons}>
        {!el.userId && <Share executor={el} />}
        {!el.userId && (
          <IconButton
            display
            onClick={() => onAttachUser(el.id!)}
            icon={qr}
            alt="Привязать пользователя"
            small
          />
        )}
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
        <IconButton display onClick={() => startDuplicate(el)} icon={copy} alt="Копировать" small />
        <IconButton display onClick={() => startEdit(el)} icon={edit} alt="Изменить" small />
      </div>
    </div>
  )
}
